module.exports = __webpack_public_path__ + "img/successsix.7b55d831.png";